module.exports = __webpack_public_path__ + "img/mindful_days_30--active.4114b109.svg";